import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'service_order';

export default {
  async getServiceOrderByHash(hash) {
    const url = mountUrl(`/${BASE_PATH}/${hash}/detail-by-hash`);
    return api.get(url);
  },
  async updateServiceOrderDetails(serviceOrderId, data) {
    if (!data || typeof data.number !== 'number' || !data.service_order_type_id || typeof data.service_order_type_id !== 'number') {
      throw new Error('Invalid data');
    }

    const url = mountUrl(`/${BASE_PATH}/${serviceOrderId}/update`);
    return api.patch(url, data);
  },
  async generatePDF(pdfUrl) {
    const url = mountUrl(`/generatePDF/service_order`);
    return api.get(url, { params: { pdf_url: pdfUrl } });
  }
};
